import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import PageWrapper from '../../components/pageWrapper/PageWrapper';
import ErrorMessage from './components/ErrorMessage';
import { performLifecycleTransition } from '../../api/TeamMemberApi';
import { TeamMemberLifecycleEvent } from '../../models/TeamMemberLifecycleEvent';
import { scoutManagerDashboardUrl } from '../../common/config';
import { getLogger } from '../../common/logger/logger';

type ParamTypes = {
  teamMemberId: string;
  invitationId: string;
};

const InvitationActivationPage: React.FC = () => {
  const log = getLogger('InvitationActivationPage');
  const { teamMemberId, invitationId } = useParams<ParamTypes>();
  const lifecycleEvent = { command: 'activate', invitationId: invitationId } as TeamMemberLifecycleEvent;
  const [error, setError] = useState<Error | undefined>(undefined);

  useEffect(() => {
    performLifecycleActivation();
  });

  const performLifecycleActivation = async () => {
    try {
      const response = await performLifecycleTransition(teamMemberId!, lifecycleEvent);
      if (response && response.phase === 'active') {
        window.location.href = scoutManagerDashboardUrl();
      } else {
        throw new Error('Unable to activate the team member');
      }
    } catch (e) {
      log.error(e);
      setError(e);
    }
  };

  return (
    <PageWrapper title='Kontoaktivierung-Erfolgreich' isWhiteHeader={true}>
      <div className='margin-vertical-xl align-center'>{error && <ErrorMessage teamMemberId={teamMemberId!} invitationId={invitationId!} />}</div>
    </PageWrapper>
  );
};
export default InvitationActivationPage;
